<script>
  import { createEventDispatcher } from 'svelte';
  import { getStr } from '../../../../common/util';
  import BundleBottomButton from './BundleBottomButton.svelte';
  import BundleBottomPriceDetails from './BundleBottomPriceDetails.svelte';

  export let currency;
  export let targetBundlePrice;
  export let initialBundlePrice;
  export let percentDiscount;
  export let installmentPrice;
  export let cartItems;
  export let savingAmount;
  export let tasheelPriceValuesList;
  export let bundleTasheelPriceValue = null;

  const bundleDispatcher = createEventDispatcher();

  function addBundleToCart() {
    bundleDispatcher('addBundleToCart', null);
  }
</script>

<section class="bundle-bottom">
  <section class="bundle-bottom-left">
    <BundleBottomPriceDetails
      {currency}
      {targetBundlePrice}
      {initialBundlePrice}
      {percentDiscount}
      {installmentPrice}
      {savingAmount}
      {tasheelPriceValuesList}
      {bundleTasheelPriceValue}
    />
  </section>

  <section class="bundle-bottom-right">
    <!-- Commenting for now as View details functionality is not clear -->
    <!-- <BundleBottomButton label={ getStr('View Details')} type={"primary"} variant={"outlined"} width={"75px"}/> -->
    <BundleBottomButton
      on:click={() => addBundleToCart()}
      label={`${getStr('extra.pdp.addalltocartlable')} (${cartItems})`}
      type="secondary"
      variant="solid"
      width="124px"
    />
  </section>
</section>

<style lang="scss">
  @import '../../../common/styles/colors.new.scss';

  .bundle-bottom {
    position: relative;
    display: flex;
    @include desktop-min-width {
      .bundle-bottom-left {
        padding-right: 20px;
      }
    }
    &-right {
      display: flex;
      gap: 12px;
      align-items: center;
      margin-left: auto;
    }
  }
</style>
